export default ({ $axios }, inject) => {
  // We define the object containing all translation logic directly here.
  const translator = {
    /**
     * Gets the current translation service from localStorage.
     * @returns {string} - e.g., 'google', 'deepl', etc.
     */
    getTranslator: () => {
      const translatorFromStorage = localStorage.getItem('translatorService')
      return translatorFromStorage ?? 'google'
    },

    /**
     * Saves the translation service to be used in localStorage.
     * @param {string | null} serviceName - e.g., 'google', 'deepl', etc., or null to reset.
     */
    setTranslator: (serviceName) => {
      if (serviceName) {
        localStorage.setItem('translatorService', serviceName)
      } else {
        localStorage.removeItem('translatorService')
      }
    },

    /**
     * Sends a translation request to the API.
     * @param {string} source - The text to be translated.
     * @param {string} language - The target language code (e.g., 'tr', 'en').
     * @param {Array} filters - The filters to be applied.
     * @param {string | null} translatorOverride - To temporarily use a different service.
     * @returns {Promise} - The Promise from the Axios request.
     */
    translate(source, language, filters = [], translatorOverride = null) {
      // We use the $axios instance passed from the plugin directly.
      // The 'this.getTranslator()' call accesses the other method within this object.
      return $axios.$post('admin/translations/translate', {
        source,
        language: this.toCode(language),
        translator: translatorOverride || this.getTranslator(),
        filters: filters || [],
      })
    },

    /**
     * Converts a language code to a specific format used by the translation service.
     * @param language
     * @returns {string}
     */
    toCode: (language) => {
      switch (language) {
        case 'en':
          return 'en-GB'
        case 'us':
          return 'en-US'
        case 'de':
          return 'de'
        case 'fr':
          return 'fr'
        case 'es':
          return 'es'
      }

      return language || 'en-GB'
    },

    /**
     * Converts a language code to a human-readable name.
     * @param language
     * @returns {string}
     */
    toName: (language) => {
      switch (language) {
        case 'en':
          return 'English'
        case 'us':
          return 'English (US)'
        case 'de':
          return 'German'
        case 'fr':
          return 'French'
        case 'es':
          return 'Spanish'
      }

      return language || 'English'
    },
  }

  // We inject the prepared 'translator' object into the application.
  inject('translator', translator)
}
